<template lang="pug">
.password-view.container
  .breadcrumb-password-view.py-3.row
    Breadcrumb(:pathList='{ "Envio de documentos": "#" }')
  .title-upload-login-view.text-start
    h2.fw-600 Envio de documentos
  .description-password-view.text-start
    p Por aqui você pode enviar os documentos que ficaram pendentes
      |
      | para a finalização da sua emissão.
  .content-password-view
    .d-flex.flex-row.row
      .col-12.col-md-6.d-none.d-md-block.text-center
        img(alt='emitir-certificado', src='@/assets/images/document.svg')
      .col-12.col-md-6
        .description-password-view.d-flex.text-start
          .text Tenha em mãos o #[strong código da solicitação] que você recebeu
            |
            | por e-mail e a sua #[strong senha de emissão].
        .input-create-user
          Input.mb-5(
            label='Código da solicitação',
            icon='lock',
            :is-required='true',
            v-model='model.codigoSolicitacao',
            placeholder='Ex: 11DE2302076A8XXX',
            type='text',
            :tooltipTitle='requestCodeTooltipText'
          )
        .input-create-password.col-12
          Input.mb-5(
            label='Senha de emissão',
            icon='lock',
            :is-required='true',
            placeholder='Digite a senha de emissão',
            type='password',
            v-model='model.password',
            :errorLog='error'
          )
          .d-flex.justify-content-end.mt-2.row
            .col-xs-12.col-lg-4
              button.btn.w-100.d-flex.justify-content-center.align-items-center(
                type='button',
                :class='!isValid ? "btn-secondary" : "btn-primary"',
                :disabled='!isValid',
                @click='submit'
              )
                .d-flex.flex-row.justify-content-end
                  span Avançar
                  Icon.ms-2(name='arrow-right')
    Contact
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import { useRoute } from 'vue-router'
  import Contact from '@/components/Molecules/Contact.vue'
  import Icon from '@/components/Atoms/Icon.vue'
  import Input from '@/components/Atoms/Input.vue'
  import Breadcrumb from '@/components/Molecules/Breadcrumbs.vue'
  import sentFilesController from '@/infra/sisAr/sentFiles.controller'
  import { useToastGlobal } from '@/store/Pinia/useToastGlobal.store'
  import { useSolicitation } from '@/store/Pinia/useSolicitation.store'
  import { useDynamicForms } from '@/store/Pinia/useDynamicForms.store'
  import { mapActions } from 'pinia'
  import { useOeRecaptcha } from '@/composables/useOeRecaptcha'

  export default defineComponent({
    name: 'HomeView',
    components: {
      Contact,
      Icon,
      Input,
      Breadcrumb,
    },
    setup() {
      return {
        oeRecaptcha: useOeRecaptcha(),
        route: useRoute(),
      }
    },
    data: () => ({
      model: {
        codigoSolicitacao: '',
        password: '',
      },
      error: '',
    }),
    computed: {
      isValid() {
        return (
          !!this.model.codigoSolicitacao && !!this.model.password && !this.error
        )
      },
      requestCodeTooltipText() {
        return 'Você pode encontrar o código da solicitação em seu e-mail com o texto: “Emissão de Certificado Digital APROVADA” no assunto.'
      },
    },
    beforeMount() {
      if (this.route.query.solicitation) {
        this.model.codigoSolicitacao = String(this.route.query.solicitation)
      }
    },
    methods: {
      ...mapActions(useToastGlobal, ['toggleToastGlobal']),
      ...mapActions(useDynamicForms, ['setPassword']),
      ...mapActions(useSolicitation, ['setCodigoSolicitacao']),
      async submit() {
        try {
          if (this.error === '' && this.isValid && this.model.password) {
            const recaptchaToken = await this.oeRecaptcha.getToken('getfiles')

            const response = await sentFilesController.login(
              this.model.codigoSolicitacao,
              this.model.password,
              recaptchaToken,
            )

            if (response) {
              this.setPassword(this.model.password)
              this.setCodigoSolicitacao(this.model.codigoSolicitacao)
              this.$router.push('/pending-upload-documents')
            }
          }
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error: any) {
          const backendMessage =
            error?.response?.data?.message ||
            error?.response?.data?.mensagem ||
            error?.message ||
            ''

          if (backendMessage) {
            this.toggleToastGlobal({
              isShow: true,
              message: backendMessage,
            })
            return
          }

          this.toggleToastGlobal({
            isShow: true,
            message: 'Erro ao realizar o login, tente novamente mais tarde.',
          })
        }
      },
    },
    beforeRouteEnter(_to, _from, next) {
      const dynamicFormsStore = useDynamicForms()
      const solicitationStore = useSolicitation()

      const pass = dynamicFormsStore.getPassword

      if (
        solicitationStore.getSolicitation.cdSolicitacao !== '' &&
        pass !== ''
      ) {
        return next({ name: 'pendingUploadFiles' })
      }

      return next()
    },
    beforeRouteLeave() {
      this.oeRecaptcha.hideBadge()
    },
    mounted() {
      this.oeRecaptcha.showBadge()
    },
  })
</script>

<style lang="stylus" scoped>
  .title-upload-login-view
    font-size: 24px
    padding-bottom: 0.5rem
  .description-password-view
    font-size: 14px
    padding-bottom: 1.5rem
</style>
